export enum LogEntriesConstantsEnums {
  GET_REFERRAL_CODES_API_FAILED = 'GET_REFERRAL_CODES_API_FAILED',
  FORM_SUBMIT_INVITE_CODE_MISMATCH = 'FORM_SUBMIT_INVITE_CODE_MISMATCH',
  FAILED_TO_GET_WEBINAR_PRODUCT_CONFIG_DATA = 'FAILED_TO_GET_WEBINAR_PRODUCT_CONFIG_DATA',
  FAILED_TO_GET_PROGRAMS_CONFIG_DATA = 'FAILED_TO_GET_PROGRAMS_CONFIG_DATA',
  GET_LOGIN_OTP_API_INITIATED = 'GET_LOGIN_OTP_API_INITIATED',
  GET_LOGIN_OTP_API_SUCCESS = 'GET_LOGIN_OTP_API_SUCCESS',
  GET_LOGIN_OTP_API_FAILED = 'GET_LOGIN_OTP_API_FAILED',
  GRAPHQL_FIELD_UPDATE_API_FAILED = 'GRAPHQL_FIELD_UPDATE_API_FAILED',
  GRAPHQL_FIELD_UPDATE_FAILURE = 'GRAPHQL_FIELD_UPDATE_FAILURE',
  APPLICATION_SECTION_PAGE_ERROR = 'APPLICATION_SECTION_PAGE_ERROR',
  NIAT_APPLICATION_WHATSAPP_COMMUNITY_LINK_ERROR = 'NIAT_APPLICATION_WHATSAPP_COMMUNITY_LINK_ERROR',
  CLEAR_USER_SESSION_AND_RELOAD = 'CLEAR_USER_SESSION_AND_RELOAD',
  CLEAR_USER_SESSION = 'CLEAR_USER_SESSION',
  EXIF_DATA_REMOVAL_ERROR = 'EXIF_DATA_REMOVAL_ERROR',
  RAZORPAY_SCRIPT_LOAD_FAILED = 'RAZORPAY_SCRIPT_LOAD_FAILED',
  TRACK_REFERRAL_ATTEMPT_API_FAILED = 'TRACK_REFERRAL_ATTEMPT_API_FAILED',
}

export enum LogEntryPriorityEnum {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW'
}

export enum LogEntryTypesEnums {
  INFORMATION = 'INFORMATION',
  ERROR = 'ERROR',
  WARNING = 'WARNING'
}
